import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Bell } from 'lucide-react';

export function NotificationsTab({ handleSendNotification, notifTitle, setNotifTitle, notifBody, setNotifBody, notifUrl, setNotifUrl, notifSending }) {
  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6 max-w-2xl">
      <h3 className="text-lg font-bold text-slate-800 mb-1">Toplu Bildirim Gönder</h3>
      <p className="text-xs text-slate-500 mb-4">Bu bildirim, sitede bildirim izni veren TÜM kullanıcılara web push olarak gönderilir.</p>
      <form onSubmit={handleSendNotification} className="space-y-3">
        <div>
          <Label>Başlık</Label>
          <Input value={notifTitle} onChange={e => setNotifTitle(e.target.value)} className="mt-1" placeholder="örn: Yeni özellik duyurusu" required data-testid="notif-title" />
        </div>
        <div>
          <Label>İçerik</Label>
          <Textarea value={notifBody} onChange={e => setNotifBody(e.target.value)} rows={3} className="mt-1 resize-none" placeholder="Kullanıcılara göstermek istediğin mesaj..." required data-testid="notif-body" />
        </div>
        <div>
          <Label>Yönlendirme URL (opsiyonel)</Label>
          <Input value={notifUrl} onChange={e => setNotifUrl(e.target.value)} className="mt-1" placeholder="/" data-testid="notif-url" />
          <p className="text-xs text-slate-400 mt-1">Tıklandığında açılacak sayfa; varsayılan ana sayfa</p>
        </div>
        <Button type="submit" disabled={notifSending} className="w-full bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="notif-send-btn">
          {notifSending ? 'Gönderiliyor...' : <><Bell className="w-4 h-4 mr-2" />Bildirim Gönder</>}
        </Button>
      </form>
    </div>
  );
}
